import React from "react";
import { Collapse } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { faqs } from "../../data/data";
import { trackCta } from "../../../../analytics";
import "./Faqs.scss";

const Faqs = ({ title = "Pricing FAQs" }) => {
  const expandIcon = ({ isActive }) => (
    <div className="faq__icon">
      <DownOutlined className={`manrope down-icon ${isActive ?  `active`: ``}`} rotate={isActive ? 180 : 0} />
    </div>
  );

  const handleChange = (activeKeys) => {
    const lastOpened = Array.isArray(activeKeys) ? activeKeys[activeKeys.length - 1] : activeKeys;
    if (lastOpened == null) return;
    const idx = Number(lastOpened);
    const item = faqs[idx];
    if (!item) return;
    trackCta("faq_open", {
      section: "pricing_faq",
      button: "faq_question",
      question: item.question,
      question_index: idx,
    });
  };

  return (
    <section id="faqs" className="faq">
      <div className="faq__container">
        <h2 className="faq__title manrope f-30 w-600 lh-58 black-085">{title}</h2>
        <Collapse
          expandIconPosition="right"
          className="faq__list"
          bordered={false}
          expandIcon={expandIcon}
          onChange={handleChange}
        >
          {faqs.map((item, index) => (
            <Collapse.Panel
              key={index}
              header={<span className="manrope f-16 lh-24 w-700 text-left w-100 black-085">{item.question}</span>}
              className="faq__item"
            >
              <div className="faq__answer manrope f-14 lh-22 w-600 black-085">{item.answer}</div>
            </Collapse.Panel>
          ))}
        </Collapse>
      </div>
    </section>
  );
};

export default Faqs;
